var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "727px",
    height: "631px",
    viewBox: "0 0 727 631",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "graphical elements / illustration / report") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "graphical-elements-/-illustration-/-report",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M624.771345,340.51338 L627.099402,321.852919 C628.822308,308.04303 641.414125,298.244595 655.224014,299.967501 C669.033903,301.690407 678.832338,314.282224 677.109433,328.092113 L674.781375,346.752565 C674.547959,348.606498 672.857899,349.921636 671.003445,349.692402 L627.711181,344.29131 C625.857246,344.057898 624.542106,342.367835 624.771345,340.51338 Z",
    id: "Path",
    fill: "#2F2E41",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FFB8B8",
    fillRule: "nonzero",
    cx: 645.508694,
    cy: 327.605568,
    r: 18.4749172
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620.997574,322.60774 C622.372157,311.690148 632.324729,303.945462 643.245396,305.295391 L646.977672,305.761025 C657.895222,307.135623 665.639842,317.088204 664.289838,328.008823 L664.243242,328.382031 L656.3561,327.398042 L654.605774,319.52973 L653.128075,326.99532 L649.051931,326.486784 L648.168838,322.516844 L647.423154,326.283584 L620.950995,322.980948 L620.997574,322.60774 Z",
    id: "Path",
    fill: "#2F2E41",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M555.148591,393.509036 C556.291676,395.753265 558.370106,397.375911 560.824616,397.94035 C563.279125,398.50479 565.857579,397.953041 567.866166,396.433571 L584.646464,406.26343 L593.107144,397.523025 L569.215151,383.974212 C566.376569,380.697151 561.535549,380.061104 557.946792,382.493695 C554.358035,384.926287 553.155895,389.658611 555.148591,393.509044 L555.148591,393.509036 Z",
    id: "Path",
    fill: "#FFB8B8",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M610.145425,411.172177 C597.767976,411.172177 575.987286,405.631273 574.781233,405.321685 L574.400337,405.224174 L577.828365,387.868117 L611.096132,394.438974 L629.169276,368.988514 L649.918823,366.879092 L649.339661,367.641268 C649.069887,367.996362 622.322579,403.206579 618.159991,409.113137 C617.109544,410.603383 614.109132,411.172177 610.145425,411.172177 Z",
    id: "Path",
    fill: "#3F3D56",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.463754,476.313344 L612.968489,476.076894 C612.863058,476.026513 602.347007,470.911404 596.900152,460.925731 C591.479307,450.987203 616.855821,408.827911 618.631075,405.902661 L618.65687,392.513972 L627.785718,367.867158 L639.427793,361.286974 L629.432143,384.609722 L613.463754,476.313344 Z",
    id: "Path",
    fill: "#3F3D56",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFB8B8",
    fillRule: "nonzero",
    points: "601.800487 620.214833 590.674046 620.214001 585.380416 577.29666 601.802151 577.297492"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M604.63792,631 L568.760849,630.998677 L568.760849,630.544891 C568.761409,622.832862 575.013177,616.581206 582.725206,616.580784 L582.726096,616.580784 L604.638586,616.581674 L604.63792,631 Z",
    id: "Path",
    fill: "#2F2E41",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFB8B8",
    fillRule: "nonzero",
    points: "721.314036 610.463804 710.740922 613.927712 692.346349 574.792961 707.951823 569.679891"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M727.369226,619.829534 L693.275455,631 L693.134153,630.56878 C690.733201,623.239987 694.727449,615.352375 702.055949,612.950529 L702.056781,612.950254 L722.880108,606.127779 L727.369226,619.829534 Z",
    id: "Path",
    fill: "#2F2E41",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M699.77091,603.446991 L668.051984,550.493329 L641.275737,493.918457 L617.180436,543.893033 L607.608585,608.618173 L574.040383,609.08459 L574.172624,608.55967 L625.542582,404.444109 L665.774833,410.454675 L663.943505,437.011023 L665.034174,438.562218 C674.122551,451.473116 683.519501,464.82199 678.129933,479.21176 L693.408661,524.578266 L727.22918,600.118694 L699.77091,603.446991 Z",
    id: "Path",
    fill: "#2F2E41",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M627.380816,448.681962 C621.551042,448.681962 614.899765,442.025401 618.35036,430.660814 L618.126907,430.499118 L626.414899,393.881537 C619.182022,383.537533 628.718127,375.000694 629.611712,374.238102 L634.163718,366.044567 L654.247975,353.307147 L664.409963,437.740723 L664.259642,437.884546 C656.920318,444.906768 632.271058,448.681962 627.380816,448.681962 Z",
    id: "Path",
    fill: "#C9B181",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M668.512618,467.734269 C667.714552,467.746653 666.917923,467.662344 666.140128,467.483183 C665.359039,467.287356 664.094484,466.292774 662.140459,459.930359 C654.372103,434.637543 645.200237,358.534012 651.863703,351.086818 L652.016263,350.916186 L662.957094,352.739584 C663.866547,352.068403 668.638976,348.736878 673.04289,349.31624 C674.87544,349.546763 676.530916,350.525305 677.616438,352.019635 L677.691798,352.11836 L681.17734,401.704943 L693.946445,460.058731 L693.64031,460.197686 C692.897396,460.535706 676.952737,467.734269 668.512618,467.734269 Z",
    id: "Path",
    fill: "#3F3D56",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M661.154681,448.353244 C663.67185,448.269264 666.022538,447.074651 667.574224,445.09085 C669.125909,443.107049 669.719202,440.53784 669.194458,438.074541 L685.210608,427.043356 L680.88084,415.675382 L658.481722,431.571248 C654.310397,432.753039 651.682225,436.867966 652.364168,441.149501 C653.04611,445.431036 656.822614,448.525857 661.154681,448.353269 L661.154681,448.353244 Z",
    id: "Path",
    fill: "#FFB8B8",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M679.925723,435.882378 L665.659458,425.420561 L685.713037,398.075195 L670.323835,370.917926 L677.208932,351.230209 L677.653814,352.078088 C677.861,352.472997 698.412498,391.623765 701.997546,397.898006 C705.727442,404.424555 681.220757,434.310015 680.175819,435.578431 L679.925723,435.882378 Z",
    id: "Path",
    fill: "#3F3D56",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.021385,558.960765 L346.879569,553.848277 L338.550331,492.981205 L227.631583,492.981205 L218.60329,553.599621 L207.740524,559.030925 C206.670495,559.565966 206.108759,560.766508 206.383649,561.930839 C206.658538,563.09517 207.697907,563.917672 208.894248,563.917672 L358.020696,563.917672 C359.248589,563.917672 360.306346,563.052296 360.549328,561.848685 C360.79231,560.645073 360.153154,559.437022 359.021385,558.960765 Z",
    id: "Path",
    fill: "#19222F",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M556.131648,501.079318 L11.2678843,501.079318 C5.31558489,501.065948 0.497319947,496.236921 0.497319947,490.284607 L0.497319947,413.451683 L566.902212,413.451683 L566.902212,490.284632 C566.902212,496.236912 562.083913,501.065889 556.131648,501.079318 L556.131648,501.079318 Z",
    id: "Path",
    fill: "#CCCCCC",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M567.471773,449.764751 L-6.82121026e-13,449.764751 L-6.82121026e-13,121.012818 C0.00829976081,113.829306 5.82974649,108.008056 13.0132594,108 L554.458339,108 C561.641887,108.008038 567.463395,113.82927 567.471773,121.012818 L567.471773,449.764751 Z",
    id: "Path",
    fill: "#3F3D56",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M533.57893,425.903903 L33.8928424,425.903903 C28.3547974,425.897831 23.8667967,421.409953 23.8605738,415.871909 L23.8605738,141.892876 C23.8667503,136.354712 28.3546788,131.866631 33.8928424,131.860266 L533.57893,131.860266 C539.117094,131.866631 543.605022,136.354712 543.611199,141.892876 L543.611199,415.871909 C543.604976,421.409953 539.116975,425.897831 533.57893,425.903903 L533.57893,425.903903 Z",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.873124,564.552625 L143.092567,564.552625 C142.501124,564.565175 141.975366,564.177922 141.811945,563.609365 C141.711384,563.22794 141.793424,562.821444 142.034048,562.508877 C142.274671,562.196309 142.646661,562.013026 143.04112,562.012681 L423.769073,562.012681 C424.393745,561.990796 424.951059,562.40242 425.11384,563.005907 C425.197247,563.382216 425.105463,563.776046 424.864283,564.076708 C424.623104,564.37737 424.258565,564.552408 423.873124,564.552625 Z",
    id: "Path",
    fill: "#19222F",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#F2F2F2",
    fillRule: "nonzero",
    x: 407.597609,
    y: 176.154383,
    width: 120.646779,
    height: 92.171145
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    x: 413.592482,
    y: 180.734313,
    width: 108.65704,
    height: 83.011277
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.829185,242.308036 C469.843563,242.308036 469.857944,242.308036 469.872327,242.307089 C485.137686,241.508581 497.155821,228.98668 497.327176,213.701412 C497.49853,198.416143 485.764132,185.627966 470.52051,184.48744 C470.336912,184.473013 470.155621,184.535852 470.020336,184.66081 C469.885431,184.783643 469.807975,184.957248 469.806677,185.139691 L469.173279,241.638912 C469.170048,242.004637 469.463476,242.303968 469.829193,242.308036 L469.829185,242.308036 Z",
    id: "Path",
    fill: "#3F3D56",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.109196,193.829992 C447.334748,193.832776 447.550039,193.924727 447.70797,194.085784 L467.158306,213.977151 C467.316338,214.137865 467.403508,214.35512 467.40047,214.580493 L467.097316,241.615639 C467.0956,241.850176 466.996007,242.073339 466.822583,242.231246 C466.648706,242.391105 466.416371,242.471783 466.18084,242.454091 C455.150254,241.628566 445.536481,234.632748 441.358053,224.39087 C437.179624,214.148992 439.15605,202.424665 446.461188,194.118626 C446.617848,193.941229 446.841099,193.836797 447.077677,193.829992 C447.088183,193.829992 447.098689,193.829992 447.109196,193.829992 Z",
    id: "Path",
    fill: "#E6E6E6",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.887443,184.256449 C467.104586,184.259119 467.312623,184.344136 467.469459,184.494338 C467.639536,184.656233 467.734237,184.881826 467.730776,185.11661 L467.457227,209.509392 C467.453336,209.852854 467.24296,210.160162 466.924173,210.288053 C466.605387,210.415944 466.240951,210.339239 466.000764,210.093697 L449.027949,192.736017 C448.865024,192.569191 448.777679,192.342826 448.786318,192.109801 C448.794957,191.876776 448.898824,191.6575 449.073655,191.503197 C454.010008,187.158189 460.267707,184.605347 466.834723,184.257531 C466.852229,184.256449 466.869927,184.256449 466.887443,184.256449 Z",
    id: "Path",
    fill: "#C9B181",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.143718,254.024058 C458.120129,256.128461 456.8312,258.011442 454.877958,258.794968 C452.924715,259.578494 450.691817,259.108265 449.22046,257.603546 C447.749102,256.098828 447.329045,253.85595 448.15616,251.920762 C448.983275,249.985575 450.894675,248.739181 452.999078,248.762771 C455.871207,248.798228 458.172653,251.151856 458.143718,254.024058 Z",
    id: "Path",
    fill: "#C9B181",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.009331,254.190705 C472.985742,256.295108 471.696814,258.178089 469.743571,258.961615 C467.790329,259.745141 465.557431,259.274912 464.086073,257.770193 C462.614716,256.265475 462.194659,254.022597 463.021774,252.087409 C463.848888,250.152222 465.760289,248.905828 467.864692,248.929418 C470.736817,248.964884 473.038257,251.318507 473.009331,254.190705 L473.009331,254.190705 Z",
    id: "Path",
    fill: "#3F3D56",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M487.874937,254.357394 C487.842722,257.230911 485.487161,259.534242 482.613643,259.502028 C479.740126,259.469814 477.436794,257.114253 477.469007,254.240736 C477.50122,251.367218 479.85678,249.063886 482.730298,249.096098 C485.60243,249.131556 487.903877,251.485189 487.874937,254.357394 Z",
    id: "Path",
    fill: "#E6E6E6",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#F2F2F2",
    fillRule: "nonzero",
    x: 406.327645,
    y: 282.831538,
    width: 120.646779,
    height: 92.171145
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    x: 412.322519,
    y: 287.411468,
    width: 108.65704,
    height: 83.011277
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#3F3D56",
    fillRule: "nonzero",
    cx: 430.758279,
    cy: 310.183137,
    r: 4.51150876
  }), /*#__PURE__*/React.createElement("path", {
    d: "M503.910931,307 C505.013942,306.998235 506.033945,307.569643 506.585977,308.498572 C507.138008,309.427501 507.138008,310.572499 506.585977,311.501428 C506.033945,312.430357 505.013942,313.001765 503.910931,313 L456.083979,313 C454.380744,313 453,311.656852 453,310 C453,308.343148 454.380744,307 456.083979,307 L503.910931,307 M503.190816,306 L455.809184,306 C454.448964,305.99789 453.191209,306.759822 452.510518,307.998294 C451.829827,309.236765 451.829827,310.763235 452.510518,312.001706 C453.191209,313.240178 454.448964,314.00211 455.809184,314 L503.190816,314 C504.551036,314.00211 505.808791,313.240178 506.489482,312.001706 C507.170173,310.763235 507.170173,309.236765 506.489482,307.998294 C505.808791,306.759822 504.551036,305.99789 503.190816,306 L503.190816,306 Z",
    id: "Shape",
    fill: "#3F3D56",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484.523675,313.540989 L448.804322,313.540989 C446.700679,313.540989 444.995338,311.835649 444.995338,309.732005 C444.995338,307.628361 446.700679,305.923021 448.804322,305.923021 L484.523675,305.923021 C486.627318,305.923021 488.332658,307.628361 488.332658,309.732005 C488.332658,311.835649 486.627318,313.540989 484.523675,313.540989 L484.523675,313.540989 Z",
    id: "Path",
    fill: "#C9B181",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#3F3D56",
    fillRule: "nonzero",
    cx: 430.758279,
    cy: 328.917111,
    r: 4.51150876
  }), /*#__PURE__*/React.createElement("path", {
    d: "M503.910931,325 C505.013942,324.998235 506.033945,325.569643 506.585977,326.498572 C507.138008,327.427501 507.138008,328.572499 506.585977,329.501428 C506.033945,330.430357 505.013942,331.001765 503.910931,331 L456.083979,331 C454.380744,331 453,329.656852 453,328 C453,326.343148 454.380744,325 456.083979,325 L503.910931,325 M503.195664,324 L455.804336,324 C453.703259,324 452,325.790861 452,328 C452,330.209139 453.703259,332 455.804336,332 L503.195664,332 C505.296741,332 507,330.209139 507,328 C507,325.790861 505.296741,324 503.195664,324 L503.195664,324 Z",
    id: "Shape",
    fill: "#3F3D56",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M498.012129,332.274929 L448.804339,332.274929 C446.700695,332.274929 444.995355,330.569589 444.995355,328.465946 C444.995355,326.362302 446.700695,324.656962 448.804339,324.656962 L498.012129,324.656962 C500.115773,324.656962 501.821113,326.362302 501.821113,328.465946 C501.821113,330.569589 500.115773,332.274929 498.012129,332.274929 Z",
    id: "Path",
    fill: "#C9B181",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#3F3D56",
    fillRule: "nonzero",
    cx: 430.758279,
    cy: 347.651084,
    r: 4.51150876
  }), /*#__PURE__*/React.createElement("path", {
    d: "M503.910931,344 C505.013942,343.998235 506.033945,344.569643 506.585977,345.498572 C507.138008,346.427501 507.138008,347.572499 506.585977,348.501428 C506.033945,349.430357 505.013942,350.001765 503.910931,350 L456.083979,350 C454.380744,350 453,348.656852 453,347 C453,345.343148 454.380744,344 456.083979,344 L503.910931,344 M503.195664,343 L455.804336,343 C453.703259,343 452,344.790861 452,347 C452,349.209139 453.703259,351 455.804336,351 L503.195664,351 C505.296741,351 507,349.209139 507,347 C507,344.790861 505.296741,343 503.195664,343 Z",
    id: "Shape",
    fill: "#3F3D56",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468.787117,351.008932 L448.804322,351.008932 C447.442164,351.010941 446.182615,350.285395 445.500954,349.106065 C444.819294,347.926736 444.819294,346.473161 445.500954,345.293832 C446.182615,344.114503 447.442164,343.388956 448.804322,343.390965 L468.787117,343.390965 C470.88856,343.394075 472.590471,345.098503 472.590471,347.199949 C472.590471,349.301394 470.88856,351.005822 468.787117,351.008932 L468.787117,351.008932 Z",
    id: "Path",
    fill: "#C9B181",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#F2F2F2",
    fillRule: "nonzero",
    x: 42.5923511,
    y: 192.461617,
    width: 337.06601,
    height: 172.746329
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    x: 53.8278845,
    y: 201.045285,
    width: 314.594943,
    height: 155.578993
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.406439,332.889197 L100.072748,332.889197 C99.6763756,332.889197 99.3550381,332.567859 99.3550381,332.171486 L99.3550381,222.251854 C99.3550381,221.855474 99.676368,221.534144 100.072748,221.534144 C100.469129,221.534144 100.790459,221.855474 100.790459,222.251854 L100.790459,331.453776 L329.406439,331.453776 C329.802819,331.453776 330.124149,331.775106 330.124149,332.171486 C330.124149,332.567867 329.802819,332.889197 329.406439,332.889197 Z",
    id: "Path",
    fill: "#3F3D56",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.071382,324.994391 L128.212592,324.994391 C127.036546,324.993084 126.083471,324.040088 126.082068,322.864042 L126.082068,294.110089 C126.083476,292.934046 127.036548,291.981052 128.212592,291.979741 L149.071382,291.979741 C150.247426,291.981052 151.200498,292.934046 151.201905,294.110089 L151.201905,322.864042 C151.200502,324.040088 150.247427,324.993084 149.071382,324.994391 L149.071382,324.994391 Z",
    id: "Path",
    fill: "#C9B181",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.109996,324.994391 L166.251207,324.994391 C165.075161,324.993084 164.122086,324.040088 164.120683,322.864042 L164.120683,266.837121 C164.122086,265.661076 165.075161,264.708079 166.251207,264.706773 L187.109996,264.706773 C188.286042,264.708079 189.239117,265.661076 189.24052,266.837121 L189.24052,322.864042 C189.239117,324.040088 188.286042,324.993084 187.109996,324.994391 L187.109996,324.994391 Z",
    id: "Path",
    fill: "#C9B181",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.148611,324.994391 L204.289822,324.994391 C203.113778,324.99308 202.160706,324.040086 202.159298,322.864042 L202.159298,294.110089 C202.160706,292.934046 203.113778,291.981052 204.289822,291.979741 L225.148611,291.979741 C226.324658,291.981047 227.277735,292.934042 227.279143,294.110089 L227.279143,322.864042 C227.277735,324.040089 226.324658,324.993085 225.148611,324.994391 Z",
    id: "Path",
    fill: "#C9B181",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.187234,324.994884 L242.328436,324.994884 C241.17924,325.019128 240.226534,324.10966 240.197904,322.960554 L240.197904,255.974938 C240.226534,254.825832 241.17924,253.916364 242.328436,253.940608 L263.187226,253.940608 C264.336419,253.916369 265.28912,254.825835 265.31775,255.974938 L265.31775,322.960529 C265.289134,324.109639 264.336434,325.019118 263.187234,324.994884 L263.187234,324.994884 Z",
    id: "Path",
    fill: "#C9B181",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.225849,324.994391 L280.367059,324.994391 C279.191014,324.993084 278.237939,324.040088 278.236536,322.864042 L278.236536,236.693312 C278.237939,235.517266 279.191014,234.56427 280.367059,234.562963 L301.225849,234.562963 C302.401895,234.56427 303.354969,235.517266 303.356373,236.693312 L303.356373,322.864042 C303.354969,324.040088 302.401895,324.993084 301.225849,324.994391 L301.225849,324.994391 Z",
    id: "Path",
    fill: "#C9B181",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#3F3D56",
    fillRule: "nonzero",
    cx: 138.641991,
    cy: 279.060963,
    r: 4.30626204
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#3F3D56",
    fillRule: "nonzero",
    cx: 176.680606,
    cy: 251.070284,
    r: 4.30626204
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#3F3D56",
    fillRule: "nonzero",
    cx: 214.71922,
    cy: 279.060963,
    r: 4.30626204
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#3F3D56",
    fillRule: "nonzero",
    cx: 252.757835,
    cy: 237.433796,
    r: 4.30626204
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#3F3D56",
    fillRule: "nonzero",
    cx: 290.796458,
    cy: 221.644185,
    r: 4.30626204
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#3F3D56",
    fillRule: "nonzero",
    points: "214.8097 280.02549 176.680922 251.46635 139.072188 279.635249 138.211827 278.486992 176.680922 249.672407 214.628309 278.09592 252.338555 236.829406 252.48916 236.767832 290.528074 221.441934 291.064759 222.773246 253.177282 238.038403"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReport);
export default __webpack_public_path__ + "static/media/report.327d29b6ae86d4ea10357544e13a163f.svg";
export { ForwardRef as ReactComponent };